import { render, staticRenderFns } from "./Datum.vue?vue&type=template&id=56405d7a&"
import script from "./Datum.vue?vue&type=script&lang=js&"
export * from "./Datum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports